import { css, SerializedStyles } from '@emotion/react';

/**
 * Truncates text with an ellipsis after `numLines` number of lines.
 * Falls back to a single truncated line when `-webkit-line-clamp` is not supported.
 * https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp
 *
 * Usage:
 *
 *  <span css={lineClamp(3)}>My Text</span>
 *
 *  <span css={[otherStyles, lineClamp(3)]}>My Text</span>
 *
 *  const styles = {
 *    text: [
 *      { padding: 24 },
 *      lineClamp(3)
 *    ]
 *  };
 *  <span css={styles.text}>My Text</span>
 */

const lineClamp = (numLines: number, safariHeight?: string): SerializedStyles => {
  return css`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: break-word;
    word-break: break-word;

    @supports (-webkit-line-clamp: ${numLines}) {
      white-space: initial;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${numLines};
    }

    ${safariHeight != null
      ? `
      @supports (-webkit-hyphens:none){
        & > div {
          height: ${safariHeight};
        }
        & p:first-child {
          margin-top: ${safariHeight && 0};
        }
        & ul:first-child {
          margin-top: ${safariHeight && 0};
        }
        & ol:first-child {
          margin-top: ${safariHeight && 0};
        }
      }
      `
      : ''}
  `;
};

export default lineClamp;
